/* =========================================================
   K. MODS RACING
   GLOBAL CURSOR GLOW | VERSION 2.0

   FEATURES
   - Supports Shopify Debut product cards
   - Supports K. Mods custom product catalogs
   - Supports Shop By Bike collection cards
   - Supports category and featured product cards
   - Tracks cursor position
   - Supports dynamically loaded Shopify content
   - Prevents duplicate initialization
   - Disables cursor tracking on touch devices
   ========================================================= */

(function () {
  'use strict';

  if (window.KModsCursorGlowInitialized) return;
  window.KModsCursorGlowInitialized = true;

  const selectors = [

    /* Shopify product cards */
    '.product-card',
    '.product-item',
    '.grid-product',
    '.collection-product-card',

    /* K. Mods product catalogs */
    '.km-product-card',
    '.kmods-product-card',

    /* Shop By Bike */
    '.km-bike-card',
    '.kmods-bike-card',

    /* Product categories */
    '.km-category-card',
    '.kmods-category-card',

    /* Featured products */
    '.kmods-feature-card',

    /* Gallery */
    '.kmods-gallery__item'

  ];

  const selectorString = selectors.join(',');

  function addGlow(element) {
    if (!element || element.classList.contains('kmods-cursor-glow')) {
      return;
    }

    element.classList.add('kmods-cursor-glow');
  }

  function initializeGlow(root) {
    root = root || document;

    if (root.matches && root.matches(selectorString)) {
      addGlow(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(selectorString).forEach(addGlow);
    }
  }

  function startGlow() {
    initializeGlow(document);

    if (!document.body) return;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          initializeGlow(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGlow);
  } else {
    startGlow();
  }

  /* =========================================================
     CURSOR TRACKING
  ========================================================= */

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType === 'touch') return;

    const target = event.target;

    if (!(target instanceof Element)) return;

    const card = target.closest('.kmods-cursor-glow');

    if (!card) return;

    const rect = card.getBoundingClientRect();

    card.style.setProperty(
      '--kmods-mx',
      (event.clientX - rect.left) + 'px'
    );

    card.style.setProperty(
      '--kmods-my',
      (event.clientY - rect.top) + 'px'
    );
  });

  /* =========================================================
     RESET CURSOR POSITION
  ========================================================= */

  document.addEventListener('pointerout', function (event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const card = target.closest('.kmods-cursor-glow');

    if (!card) return;

    if (
      event.relatedTarget &&
      card.contains(event.relatedTarget)
    ) {
      return;
    }

    card.style.setProperty('--kmods-mx', '50%');
    card.style.setProperty('--kmods-my', '50%');
  });

  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener('shopify:section:load', function (event) {
    initializeGlow(event.target);
  });

})();